import { render, staticRenderFns } from "./PartNumberCreateContainer.vue?vue&type=template&id=badc90b8"
import script from "./PartNumberCreateContainer.vue?vue&type=script&lang=js"
export * from "./PartNumberCreateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports